import { create, v } from '@dojo/framework/core/vdom';

import { createNlsMiddleware } from 'lcc-state';

interface ScoreIconProps {
	score: number;
	useMidScore?: boolean;
}

const factory = create({
	nls: createNlsMiddleware('ditabook')
}).properties<ScoreIconProps>();

export const ScoreIcon = factory(({ middleware: { nls }, properties }) => {
	const {
		messages: { assess_progress_threshold_low = '60', assess_progress_threshold_high = '80' }
	} = nls();
	const { score, useMidScore = true } = properties();

	const lowScore = parseInt(assess_progress_threshold_low) || 60;
	const highScore = parseInt(assess_progress_threshold_high) || 80;

	if (score <= 0) {
		return v('img', {
			src: `${window.hcstatic.portal_cdn}/js/images/icons/info-circle.svg`,
			alt: `Icon indicating that no score is available`
		});
	}

	if (score < lowScore) {
		return v('img', {
			src: `${window.hcstatic.portal_cdn}/js/images/icons/alert-triangle.svg`,
			alt: `Icon indicating that the score is below the low threshold`
		});
	}
	if (score < highScore && useMidScore) {
		return v('img', {
			src: `${window.hcstatic.portal_cdn}/js/images/icons/alert-triangle.svg`,
			alt: `Icon indicating that the score is below the high threshold`
		});
	}
	return v('img', {
		src: `${window.hcstatic.portal_cdn}/js/images/icons/circle-check-complete.svg`,
		alt: `Icon indicating that the score is above the high threshold`
	});
});

export default ScoreIcon;
